document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product-card-slider').forEach(slider => {
        const wrapper = slider.querySelector('.images-wrapper');
        const images = slider.querySelectorAll('img');
        const pagination = slider.querySelector('.product-card_img-pagination');
        if (!wrapper || !images || images.length === 0 || !pagination) {
            return;
        }

        let index = 0;
        const total = images.length;        

        for (let i = 0; i < total; i++) {
            const dot = document.createElement('span');
            if (i === 0) dot.classList.add('active');
            pagination.appendChild(dot);
        }
        const dots = pagination.querySelectorAll('span');

        function updateSlider() {
            wrapper.style.transform = `translateX(-${index * 100}%)`;
            dots.forEach(d => d.classList.remove('active'));
            dots[index].classList.add('active');
        }

        const btnLeft = slider.querySelector('.slide-left');
        const btnRight = slider.querySelector('.slide-right');

        if (btnLeft) {
            btnLeft.addEventListener('click', () => {
                event.preventDefault();
                event.stopPropagation(); 
                index = index === 0 ? total - 1 : index - 1;
                updateSlider();
            });
        }

        if (btnRight) {
            btnRight.addEventListener('click', () => {
                event.preventDefault();
                event.stopPropagation();
                index = index === total - 1 ? 0 : index + 1;
                updateSlider();
            });
        }

        dots.forEach((dot, i) => {
            dot.addEventListener('click', () => {
                index = i;
                updateSlider();
            });
        });
    });
});